<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px mgb-20px">
            <h1 class="title is-size-3">
              {{ title }}
            </h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-12">
          <b-field :label="$t('detailCommande.dupliquer.dateCampagne')"
                   class="obligatoire">
            <b-datepicker show-week-number
                          v-model="newDateCmd"
                          icon="calendar-today"
                          editable
                          nearby-selectable-month-days>
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit"
               :disabled="!newDateCmd"
               :class="{'pointer-events-none' : !newDateCmd}"
               @click="$emit('dupliquer', newDateCmd)">
              {{ $t('general.button.next')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      newDateCmd: null,
    };
  },
  mounted() {
    if (this.date) this.newDateCmd = moment(this.date).toDate();
  },
};

</script>
